export default {
	namespaced: true,
	state: {
		buildingByStatusData: [],
		buildingCounters: [],
		bread_active: null,
		bread_list: null,
		componentKey: 0,
	},
	getters: {},
	mutations: {
		SET_DATA: function (state, data) {
			eval("state." + data.name + " = data.data;");
		}
	},
	actions: {
		buildingsByStatus(state) {
			axios.get('/api/v1/dashboard/buildingsByStatus')
				.then(function (response) {
					state.commit('SET_DATA', { name: 'buildingByStatusData', data: response.data.data });
					state.commit('SET_DATA', { name: 'buildingCounters', data: response.data.counters });

				}).catch(error => {
					if (error.response.status === 401) {
						window.location.href = '/login?msg=session_expired';
					}

				});
		}
	}
}
